import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Tempotravelleronrentinpune() {



const cardData = {
  keyword: "Tempo Traveller on Rent in Pune",
  heading: "Lotus Cab: Tempo Traveller on Rent in Pune",

  headingDescription:
    "Lotus Cab offers spacious and comfortable Tempo Traveller on rent in Pune for family trips, corporate outings, weddings, school tours, and outstation travel. Our fleet includes 12, 14, 17, and 20-seater AC Tempo Travellers designed for smooth long-distance journeys. Each vehicle is well-maintained, sanitized, and driven by experienced professional chauffeurs. We provide transparent per-km pricing with flexible local and outstation packages. Whether you need a luxury Maharaja Traveller or a budget-friendly group travel vehicle, Lotus Cab ensures safe, convenient, and comfortable transportation across Pune and beyond.",

  top: "Top Places to Visit in Pune with Tempo Traveller",

  topPlaces: [
    {
      title: "Shaniwar Wada",
      description:
        "Historic fort built in the 18th century. Symbol of Pune’s Maratha heritage. Ideal for group sightseeing tours. Spacious Tempo Traveller makes travel comfortable. Perfect for school and family trips."
    },
    {
      title: "Sinhagad Fort",
      description:
        "Popular trekking and historical destination near Pune. Scenic hill views attract tourists. Ideal for picnic groups. AC Tempo Traveller ensures relaxed travel."
    },
    {
      title: "Aga Khan Palace",
      description:
        "Important monument of Indian freedom movement. Suitable for educational tours. Spacious seating supports group visits. Comfortable local travel guaranteed."
    },
    {
      title: "Dagdusheth Ganpati Temple",
      description:
        "Famous spiritual landmark in Pune. Visited by families and devotees. Ideal for group darshan trips. Safe and smooth travel ensured."
    },
    {
      title: "Khadakwasla Dam",
      description:
        "Popular picnic spot near Pune. Perfect for weekend outings. Large groups prefer Tempo Traveller. Comfortable round trip travel available."
    },
    {
      title: "Lavasa",
      description:
        "Beautiful hill city near Pune. Ideal for corporate outings and family tours. AC Tempo Traveller ensures scenic highway comfort."
    },
    {
      title: "Mahabaleshwar",
      description:
        "Popular hill station destination. Frequently booked for group travel. Spacious luggage area provided. Safe long-distance journey guaranteed."
    },
    {
      title: "Lonavala",
      description:
        "Weekend getaway near Pune. Ideal for group picnic and school trips. Comfortable travel with experienced driver."
    }
  ],

  services: [
    {
      name: "Tempo Traveller on Rent in Pune",
      description:
        "Spacious Tempo Traveller rental in Pune for family and corporate trips. Available in multiple seating capacities. AC vehicles with professional drivers. Transparent per-km pricing maintained."
    },
    {
      name: "12 Seater Tempo Traveller Pune",
      description:
        "Comfortable 12-seater Tempo Traveller ideal for small groups. AC seating available. Suitable for local and outstation travel. Budget-friendly rates."
    },
    {
      name: "14 Seater Tempo Traveller Pune",
      description:
        "Well-maintained 14-seater vehicle for family tours and corporate travel. Comfortable pushback seats. Professional driver included."
    },
    {
      name: "17 Seater Tempo Traveller Pune",
      description:
        "Spacious 17-seater option for medium-sized groups. Ideal for wedding and pilgrimage trips. Smooth highway performance."
    },
    {
      name: "20 Seater Tempo Traveller Pune",
      description:
        "Large capacity Tempo Traveller for school and corporate trips. Extra luggage space provided. Comfortable AC travel ensured."
    },
    {
      name: "Luxury Tempo Traveller Pune",
      description:
        "Premium Maharaja Tempo Traveller with luxury interiors. Ideal for VIP and wedding events. Spacious and comfortable seating."
    },
    {
      name: "Tempo Traveller for Outstation Pune",
      description:
        "Reliable outstation Tempo Traveller rental for long-distance group travel. Experienced drivers ensure safety."
    },
    {
      name: "Online Tempo Traveller Booking Pune",
      description:
        "Easy online booking for Tempo Traveller rental in Pune. Instant confirmation and 24/7 customer support."
    }
  ],

  tableData: [
    ["Tempo Traveller on Rent in Pune", "12 Seater Tempo Traveller Pune"],
    ["14 Seater Tempo Traveller Pune", "17 Seater Tempo Traveller Pune"],
    ["20 Seater Tempo Traveller Pune", "AC Tempo Traveller Pune"],
    ["Luxury Tempo Traveller Pune", "Maharaja Tempo Traveller Pune"],
    ["Tempo Traveller for Outstation Pune", "Tempo Traveller for Wedding Pune"],
    ["Corporate Tempo Traveller Pune", "School Trip Tempo Traveller Pune"],
    ["Picnic Tempo Traveller Pune", "Family Tour Tempo Traveller Pune"],
    ["Tempo Traveller Per Km Rate Pune", "Affordable Tempo Traveller Pune"],
    ["Driver Included Tempo Traveller Pune", "Online Tempo Traveller Booking Pune"],
    ["Group Travel Vehicle Pune", "Mini Bus Alternative Pune"]
  ],

  whychoose: [
    { WhyChooseheading: "Spacious Group Travel", WhyChoosedescription: "Multiple seating capacity options available for group comfort." },
    { WhyChooseheading: "Transparent Pricing", WhyChoosedescription: "Clear per-km fare structure with no hidden charges." },
    { WhyChooseheading: "Professional Drivers", WhyChoosedescription: "Experienced chauffeurs for long-distance and city travel." },
    { WhyChooseheading: "Luxury Options Available", WhyChoosedescription: "Premium Maharaja Traveller available for special occasions." },
    { WhyChooseheading: "24/7 Booking Support", WhyChoosedescription: "Round-the-clock customer assistance available." },
    { WhyChooseheading: "AC & Non-AC Options", WhyChoosedescription: "Comfortable climate-controlled vehicles available." },
    { WhyChooseheading: "Safe Highway Travel", WhyChoosedescription: "Reliable and secure long-distance travel." },
    { WhyChooseheading: "Ideal for All Occasions", WhyChoosedescription: "Perfect for weddings, school trips, corporate events, and tours." }
  ]
};

const faqData = [
  { question: "Do you provide 12 seater Tempo Traveller?", answer: "Yes, 12 seater AC Tempo Traveller available in Pune." },
  { question: "Is driver included?", answer: "Yes, professional driver included with every booking." },
  { question: "Are vehicles AC?", answer: "Yes, AC and luxury options available." },
  { question: "Is outstation booking available?", answer: "Yes, outstation Tempo Traveller rental available." },
  { question: "Is online booking possible?", answer: "Yes, instant online booking available." },
  { question: "Do you provide luxury Maharaja Traveller?", answer: "Yes, luxury Maharaja option available." },
  { question: "Is per km rate available?", answer: "Yes, transparent per km pricing provided." },
  { question: "Is vehicle sanitized?", answer: "Yes, regularly cleaned and sanitized vehicles." },
  { question: "Can I book for wedding?", answer: "Yes, wedding and event bookings available." },
  { question: "Is 24/7 support available?", answer: "Yes, round-the-clock booking support provided." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nitin Kulkarni",
    feedback:
      "Booked 17-seater Tempo Traveller for family trip. Comfortable seating and smooth ride. Very professional service.",
    rating: 5
  },
  {
    id: 2,
    name: "School Coordinator",
    feedback:
      "Used 20-seater Tempo Traveller for school trip. Safe driving and punctual service. Highly reliable.",
    rating: 5
  },
  {
    id: 3,
    name: "Corporate Client",
    feedback:
      "Booked luxury Tempo Traveller for corporate outing. Excellent vehicle quality and professional driver.",
    rating: 5
  }
];






































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tempo Traveller on Rent in Pune",
  "image": "https://lotuscab.com/assets/images/tempo-traveller-rent-pune.jpg", 
  "description": "Lotus Cab offers Tempo Travellers on rent in Pune, including 12, 14, 17, and 20 seater options. Perfect for family tours, school trips, corporate travel, weddings, picnics, and outstation journeys. Choose AC and luxury variants with professional drivers and affordable per km rates, all available with instant online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "5400"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5999",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/tempo-traveller-on-rent-pune"
  }
};





  return (
    <div>
      


<Helmet>
  <title>Contact: +91 8767592195 | Tempo Traveller on Rent in Pune | Lotus Cab</title>
  <meta 
    name="description" 
    content="Rent Tempo Travellers in Pune with Lotus Cab. 12, 14, 17 & 20 seater AC & luxury vehicles for family trips, corporate travel, weddings, school trips & picnics. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Tempo Traveller on Rent in Pune, 12 Seater Tempo Traveller Pune, 14 Seater Tempo Traveller Pune, 17 Seater Tempo Traveller Pune, 20 Seater Tempo Traveller Pune, AC Tempo Traveller Pune, Luxury Tempo Traveller Pune, Maharaja Tempo Traveller Pune, Tempo Traveller for Outstation Pune, Tempo Traveller for Wedding Pune, Corporate Tempo Traveller Pune, School Trip Tempo Traveller Pune, Picnic Tempo Traveller Pune, Family Tour Tempo Traveller Pune, Tempo Traveller Per Km Rate Pune, Affordable Tempo Traveller Pune, Driver Included Tempo Traveller Pune, Online Tempo Traveller Booking Pune, Group Travel Vehicle Pune, Mini Bus Alternative Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/35.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Tempotravelleronrentinpune;